import { React, styled, mq } from 'x'

const Wrapper = styled.div`
  color: #fff;
`

const CTAButtonAfter = styled.div`
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  height: 100%;
  border-radius: 60px;
  width: 47px;
  background-color: rgb(255, 255, 255);
  transition: all 0.3s ease;
  opacity: 0.4;
  z-index: -1;

  ${mq.below('sm')} {
    width: 45px;
  }
`

const CTAButton = styled.span`
  //margin-right: 40px; // Disabled until language switcher is enabled again
  color: rgba(255, 255, 255, 0.7);
  position: relative;
  display: inline-block;
  padding: 12px 13px;
  cursor: pointer;
  transition: color 0.3s ease-out;
  font-family: 'Dosis', Helvetica, Arial, sans-serif;
  font-feature-settings: 'ss03';
  font-size: 19px;
  top: 1px;

  &:hover {
    ${CTAButtonAfter} {
      width: 100%;
    }
  }

  > span {
    color: #fff;
  }

  &:hover {
    color: rgba(255, 255, 255, 1);
  }
`

const scrollToForm = () => {
  document.querySelector('#get-in-touch-form').scrollIntoView({
    behavior: 'smooth',
  })
}

const LanguageSwitcher = ({ alternates }) => {
  return typeof alternates === 'undefined' ? (
    <React.Fragment />
  ) : (
    <Wrapper>
      <CTAButton onClick={scrollToForm}>
        <span>GET</span> IN TOUCH
        <CTAButtonAfter id="get-in-touch" />
      </CTAButton>
      {/*{*/}
      {/*language === 'en'*/}
      {/*? <Active>EN</Active>*/}
      {/*: <LanguageLink to={ alternates.en.path }>EN</LanguageLink>*/}
      {/*}*/}
      {/*|*/}
      {/*{*/}
      {/*language === 'nl'*/}
      {/*? <Active>NL</Active>*/}
      {/*: <LanguageLink to={ alternates.nl.path }>NL</LanguageLink>*/}
      {/*}*/}
    </Wrapper>
  )
}

export default LanguageSwitcher
